import { useState } from 'react';
import withRouter from '@utils/wrappers/WithRouter';
import * as yup from 'yup';
import CrudPage from '@modules/cruds/CrudPage';
import OrganizationForm from './OrganizationForm';

import AddressesListAdd from '../Addresses/AddressesListAdd';
import ContactData from '../ContactData/ContactData';
import { defaultConfigComponent } from './Organizations';
import { Tabs } from '@ts/storybook';
import { useRouterContext } from '@utils/context/RouterContext';
import OrganizationSettings from '../Parameters/DataGridParameterSettings';

const organizationSchema = yup.object().shape({
  name: yup.string().required().label('Name'),
});

const OrganizationPage = props => {
  const [state, setState] = useState({ activeTab: 'information' });
  const { transferPropsRoute } = useRouterContext();
  const organizationId = transferPropsRoute.params.id;

  const tabs = [
    { label: 'Information', value: 'information' },
    {
      label: 'Contact data',
      value: 'contactData',
    },
    {
      label: 'Addresses',
      value: 'addresses',
    },
    {
      label: 'Settings',
      value: 'settings',
    },
  ];

  const onChangeTab = (event, tab) => {
    return setState({ activeTab: tab });
  };

  //#region Renders
  const renderContents = () => {
    switch (state.activeTab) {
      case 'information':
        return renderInformation();
      case 'contactData':
        return renderContactData();
      case 'addresses':
        return renderAddresses();
      case 'settings':
        return renderSettings();
    }
  };

  const renderInformation = () => {
    return (
      <CrudPage
        key={'organization-information'}
        configComponent={defaultConfigComponent}
        form={OrganizationForm}
        defaultValues={{}}
        validationSchema={organizationSchema}
      />
    );
  };

  const renderContactData = () => {
    return (
      <ContactData
        {...Object.assign({}, props, {
          type: 'organization',
          xTypeId: organizationId,
          entity: 'taOrganization',
        })}
      />
    );
  };

  const renderAddresses = () => {
    return (
      <AddressesListAdd
        {...Object.assign({}, props, {
          type: 'organization',
          xTypeId: organizationId,
          entity: 'taOrganization',
        })}
      />
    );
  };

  const renderSettings = () => {
    return (
      <CrudPage
        {...props}
        key={'organization-settings'}
        configComponent={defaultConfigComponent}
        form={OrganizationSettings}
        validationSchema={organizationSchema}
      />
    );
  };
  //#endregion

  return (
    <Tabs id={'organization-page'} sticky tabs={tabs} value={state.activeTab} onChange={onChangeTab}>
      {renderContents()}
    </Tabs>
  );
};

export default withRouter(OrganizationPage);
